<template>
  <div class="modal topup-modal">
    <div class="overlay" @click="closeWithdraw" />
    <div class="wrapper">
      <button class="close" @click="closeWithdraw">
        <img src="@/assets/img/closeNew.svg" alt="close new" srcset="" />
      </button>
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <div class="form-fields">
              <!-- Step 2: Amount Form -->
              <Form
                v-if="step === 2"
                ref="form"
                :validation-schema="amountSchema"
                @submit="onAmountSubmit"
                v-slot="{ meta }"
              >
                <div class="form-fields-wrapper">
                  <div class="cart-up">
                    <div class="cart-top">
                      <div class="title text-white">
                        <b>{{ $t("Withdraw") }}</b>
                      </div>
                    </div>
                    <div class="topup-form">
                      <label class="input-container">
                        <Field name="amount" v-slot="{ field, errorMessage }">
                          <input
                            v-bind="field"
                            :value="amount"
                            :placeholder="$t('Amount')"
                            @input="
                              (e) => {
                                const v = sanitizePrice(e.target.value);
                                amount = v; // keep component state updated
                                field.onChange(v); // keep vee-validate updated
                              }
                            "
                            @blur="
                              (e) => {
                                const v = amountBlurSanitize(e.target.value);
                                amount = v;
                                field.onChange(v);
                              }
                            "
                          />
                          <span v-if="errorMessage" class="error">{{
                            $t(errorMessage)
                          }}</span>
                        </Field>
                      </label>
                    </div>
                  </div>

                  <div class="cart-bottom">
                    <button
                      type="submit"
                      :disabled="!meta.valid"
                      class="button red w-130"
                    >
                      {{ $t("Next") }}
                    </button>
                  </div>
                </div>
              </Form>

              <!-- Step 3: Card Form -->
              <Form
                v-if="step === 3"
                :validation-schema="cardSchema"
                @submit="onCardSubmit"
                v-slot="{ meta }"
                ref="card_form"
              >
                <div class="form-fields-wrapper">
                  <div class="cart-up">
                    <div class="cart-top">
                      <div class="title text-white">
                        <b>{{ $t("Withdraw") }}</b>
                      </div>
                    </div>
                    <div class="topup-form">
                      <label class="input-container">
                        <div class="desc">{{ $t("Card number") }}</div>
                        <Field
                          name="formattedPan"
                          v-slot="{ field, errorMessage }"
                        >
                          <input
                            type="text"
                            :placeholder="$t('Card number')"
                            :value="formattedPan"
                            @input="
                              formattedPan = formatCardNumber(
                                $event.target.value,
                              );
                              field.onChange($event);
                            "
                          />
                          <span v-if="errorMessage" class="error">{{
                            $t(errorMessage)
                          }}</span>
                        </Field>
                      </label>

                      <label class="input-container">
                        <div class="desc">
                          {{ $t("Expiration Date") }} (MM/YY)
                        </div>
                        <Field
                          name="expiration_date"
                          v-slot="{ field, errorMessage }"
                        >
                          <input
                            type="text"
                            :placeholder="$t('MM/YY')"
                            :value="expiration_date"
                            @input="
                              expiration_date = formatExpirationDate(
                                $event.target.value,
                              );
                              field.onChange($event);
                            "
                          />
                          <span v-if="errorMessage" class="error">{{
                            $t(errorMessage)
                          }}</span>
                        </Field>
                      </label>

                      <label class="input-container">
                        <div class="desc">{{ $t("Card Holder Name") }}</div>
                        <Field
                          name="card_holdername"
                          v-slot="{ field, errorMessage }"
                        >
                          <input
                            type="text"
                            :placeholder="$t('Card Holder Name')"
                            :value="card_holdername"
                            @input="
                              card_holdername = formatCardHolderName(
                                $event.target.value,
                              );
                              field.onChange($event);
                            "
                          />
                          <span v-if="errorMessage" class="error">{{
                            $t(errorMessage)
                          }}</span>
                        </Field>
                      </label>
                    </div>
                  </div>

                  <div class="cart-bottom">
                    <button
                      type="submit"
                      :disabled="!meta.valid"
                      class="button red w-130"
                    >
                      {{ $t("Withdraw") }}
                    </button>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Form, Field } from "vee-validate";
import * as yup from "yup";

export default {
  name: "PayoutModal",
  components: {
    Form,
    Field,
  },
  data() {
    return {
      step: 2,
      amount: "",
      formattedPan: "",
      expiration_date: "",
      card_holdername: "",
      amountSchema: yup.object({
        amount: yup
          .string()
          .required("Amount is required")
          .matches(/^\d+(\.\d{1,2})?$/, "Invalid amount format")
          .test(
            "min",
            "Minimum amount is 0.01",
            (value) => parseFloat(value) >= 0.01,
          ),
      }),
      cardSchema: yup.object({
        formattedPan: yup
          .string()
          .required("Card number is required")
          .matches(
            /^\d{4}\s\d{4}\s\d{4}\s\d{4}$/,
            "Invalid card number format",
          ),
        expiration_date: yup
          .string()
          .required("Expiration date is required")
          .matches(/^\d{2}\/\d{2}$/, "Invalid format, use MM/YY"),
        card_holdername: yup
          .string()
          .required("Card holder name is required")
          .matches(/^[A-Za-z]+\s[A-Za-z]+$/, "Invalid name format"),
      }),
    };
  },
  methods: {
    sanitizePrice(value) {
      console.log(value, "value");

      value = value.replace(/[^0-9.]/g, "");
      const parts = value.split(".");
      if (parts.length > 2) value = parts[0] + "." + parts[1];
      if (parts[1]) value = parts[0] + "." + parts[1].slice(0, 2);
      if (value.startsWith(".")) value = "0" + value;
      return value;
    },
    amountBlurSanitize(value) {
      if (value && value.endsWith(".")) {
        return value.slice(0, -1);
      }

      return value;
    },
    onAmountInput(event) {
      let value = event.target.value;

      // Удаляем все кроме цифр и точки
      value = value.replace(/[^0-9.]/g, "");

      // Оставляем только одну точку
      const parts = value.split(".");
      if (parts.length > 2) {
        value = parts[0] + "." + parts[1];
      }

      // Ограничиваем до 2 знаков после точки
      if (parts[1]) {
        parts[1] = parts[1].slice(0, 2);
        value = parts[0] + "." + parts[1];
      }

      // Если начинается с точки, добавляем 0 перед ней
      if (value.startsWith(".")) {
        value = "0" + value;
      }

      this.amount = value;

      // Обновим значение поля vee-validate вручную
      this.$refs.form.setFieldValue("amount", value);
    },
    formatCardNumber(value) {
      value = value.replace(/\D/g, "");
      if (value.length > 16) value = value.slice(0, 16);
      return value.replace(/(\d{4})(?=\d)/g, "$1 ");
    },
    formatExpirationDate(value) {
      value = value.replace(/\D/g, "");
      if (value.length > 4) value = value.slice(0, 4);
      if (value.length > 2) {
        value = value.slice(0, 2) + "/" + value.slice(2);
      }
      const [month] = value.split("/");
      if (month && parseInt(month, 10) > 12) {
        value = "12" + value.slice(2);
      }
      return value;
    },
    formatCardHolderName(value) {
      value = value.replace(/[^A-Za-z\s]/g, "").replace(/\s+/g, " ");
      const words = value.trim().split(" ");
      if (words.length > 2) value = words.slice(0, 2).join(" ");
      return value.toUpperCase();
    },
    onAmountSubmit() {
      this.amount = parseFloat(this.amount).toFixed(2);
      this.step = 3;
    },
    async onCardSubmit() {
      try {
        const [expiry_month, expiry_year] = this.expiration_date.split("/");
        const data = {
          amount: this.amount,
          currency: this.$parent.currencyCode,
          card_number: this.formattedPan.replace(/\s+/g, ""),
          expiry_month,
          expiry_year,
          cardholder_name: this.card_holdername,
        };
        await this.$http.post(process.env.VUE_APP_API + `payouts`, data);
        this.closeWithdraw();
        this.$emit("closeWithdraw");
      } catch (error) {
        if (error.response) {
          if (error.response.data.errors) {
            this.$refs.card_form.setErrors(error.response.data.errors);
          } else if (
            error.response.data.status === "ERROR" &&
            error.response.data.message
          ) {
            this.$refs.card_form.setErrors({
              card_holdername: error.response.data.message,
            });
          }
        }
      }
    },
    closeWithdraw() {
      this.step = 2;
      this.amount = "";
      this.formattedPan = "";
      this.expiration_date = "";
      this.card_holdername = "";
      this.$emit("closeWithdraw");
    },
  },
};
</script>

<style scoped>
.topup-form {
  margin-top: 64px;
}
.input-container {
  max-width: 372px;
  margin: 0 auto 16px;
}
</style>
